import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { ChatMessage, GroupChatService } from './groupchat.service';
 
@Component({
  selector: 'app-groupchat',
  templateUrl: './groupchat.component.html',
  styleUrls: ['./groupchat.component.scss']
})
export class GroupchatComponent implements OnInit, OnDestroy {
  messages: ChatMessage[] = [];
  newMessage: string = '';
  typing: string | false = false;
 
  private typingTimeout: any;
  private subscriptions: Subscription[] = [];
 
  userId: string = '';
  threadId: number = 1; // static thread ID
 
  constructor(
    private groupChatService: GroupChatService,
    private location: Location
  ) {}
 
  ngOnInit(): void {
    this.userId = this.getCurrentUserId();
    this.groupChatService.userId = this.userId; // ✅ Set the userId in service
    this.groupChatService.joinGroupChat(this.userId, this.threadId.toString());
 
    this.subscriptions.push(
      this.groupChatService.messages$.subscribe(messages => {
        this.messages = messages;
        this.scrollToBottom();
 
        // ✅ Mark messages as read when received
        this.groupChatService.markGroupMessagesAsRead(this.threadId.toString());
      }),
 
      this.groupChatService.typing$.subscribe(data => {
        if (!data || data.sender_id === this.userId || !data.isTyping) {
          this.typing = false;
        } else {
          this.typing = `${data.sender_name || 'Someone'} is typing...`;
        }
      })
    );
  }
 
  sendMessage(): void {
    const trimmed = this.newMessage.trim();
    if (!trimmed) return;
 
    this.groupChatService.sendMessage(trimmed);
    this.newMessage = '';
    this.groupChatService.sendTypingStatus(false);
  }
 
  onInput(): void {
    this.groupChatService.sendTypingStatus(true);
 
    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(() => {
      this.groupChatService.sendTypingStatus(false);
    }, 2000);
  }
 
  onCloseChat(): void {
    this.location.back();
  }
 
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.groupChatService.disconnect();
  }
 
  private getCurrentUserId(): string {
    const userDetails = JSON.parse(localStorage.getItem('user_details') || '{}');
    return userDetails?.employeeId?.toString() || 'default-user-id';
  }
 
  private scrollToBottom(): void {
    setTimeout(() => {
      const container = document.querySelector('.chat-messages');
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }, 100);
  }
}
 